import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COMPLETED } from '../../reducers/currentMonitoredUri';
import { fetchCrawlStatus } from '../../actions/crawls';
import { selectLastCrawlId } from '../../selectors/crawlIdSelector';

// A page is "stale" when the snapshot being viewed is the page's latest, yet
// the workspace's most recent completed crawl started after it — that crawl
// skipped this page.
export function useStaleness() {
    const dispatch = useDispatch();
    const { curSnapshotDate, lastSnapshotDate, pageSnapshotsMap } = useSelector(s => s.currentMonitoredUri);
    const lastCrawlId = useSelector(selectLastCrawlId);
    const workspaceLastCrawl = useSelector(s => s.crawls?.crawls?.[lastCrawlId]);

    useEffect(() => {
        if (lastCrawlId && !workspaceLastCrawl) dispatch(fetchCrawlStatus(lastCrawlId));
    }, [dispatch, lastCrawlId, workspaceLastCrawl]);

    const isLatest = curSnapshotDate && curSnapshotDate === lastSnapshotDate;
    const snap = pageSnapshotsMap?.[curSnapshotDate];
    const createDate = snap?.fetchStatus === COMPLETED ? snap.createDate : null;

    const isStale = isLatest
        && createDate
        && workspaceLastCrawl?.completedAt
        && workspaceLastCrawl?.startedAt
        && new Date(createDate) < new Date(workspaceLastCrawl.startedAt);

    return { isStale, createDate };
}
